import React, { useEffect, useState } from "react";
import { FetchFamilyHistory } from "../../../../api/helper";
import { FamilyHistorydata } from "../../../AgencyFlow/AgencyScreens/Patientinfoeditscreens/Historydata";

const PatientFamilyHistory = () => {
  const [isFamilyHistoryOpen, setIsFamilyHistoryOpen] = useState(false);

  const [formData, setFormData] = useState({
    generalHealthConditions: {
      noHealthConcern: false,
      arthritis: false,
      asthma: false,
      bleedingDisorder: false,
      cadUnder55: false,
      copd: false,
      diabetes: false,
    },
    cardiovascularAndOthers: {
      heartAttack: false,
      heartDisease: false,
      highCholesterol: false,
      hypertension: false,
      mentalIllness: false,
      osteoporosis: false,
      stroke: false,
    },
    cancer: {
      breastCA: false,
      colonCA: false,
      ovarianCA: false,
      prostateCA: false,
      uterineCA: false,
      otherCA: false,
      otherCAText: "",
    },
  });

  const Getfamilyhistory = async () => {
    const agencyId = "680b1432319b16c8ea4c1dbf";
    const patientId = "681b328d561a4d17220aad65";
    try {
      const response = await FetchFamilyHistory(agencyId, patientId);
      const data = response?.data?.data;

      if (data && Object.keys(data).length > 0) {
        setFormData({
          generalHealthConditions: data.generalHealthConditions || {},
          cardiovascularAndOthers: data.cardiovascularAndOthers || {},
          cancer: data.cancer || {},
        });
      }
    } catch (error) {
      console.log("Error fetching family history:", error);
    }
  };

  useEffect(() => {
    Getfamilyhistory();
  }, []);

  // ✅ Handle checkbox toggle
  const handleCheckboxChange = (category, key, checked) => {
    setFormData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: checked,
      },
    }));
  };

  // ✅ Handle "Other" text input
  const handleOtherTextChange = (category, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [`${key}Text`]: value,
      },
    }));
  };

  // ✅ Collect all fields for summary
  const allFields = [
    ...Object.entries(formData.generalHealthConditions),
    ...Object.entries(formData.cardiovascularAndOthers),
    ...Object.entries(formData.cancer),
  ];

  const trueFields = allFields.filter(([key, value]) => value === true);
  const falseFields = allFields.filter(([key, value]) => value === false);

  const displayedFields = [
    ...trueFields.slice(0, 5),
    ...falseFields.slice(0, 5 - trueFields.length),
  ];
  

  const renderFamilyHistory = (key, value) => {
    return (
      <div key={key} className="space_between" style={{ marginTop: 19 }}>
        <div className="smoking_txt1">
          {key.replace(/([A-Z])/g, " $1").toUpperCase()}
        </div>
        <div className="smoking_txt1">{value ? "YES" : "NO"}</div>
      </div>
    );
  };

  return (
    <div className="Lifestyle_Determinants_chart1">
      <div className="Lifestyle_Determinants_div1">
        Family History
        <div
          onClick={() => {
            setIsFamilyHistoryOpen(true);
          }}
        >
          <img
           src={require("../../../assest/Images/pen_icon.png")}
            alt="Plus Icon"
          />
        </div>
      </div>

      {/* ✅ Summary like LifestyleHistory */}
      {displayedFields.map(([key, value]) =>
        renderFamilyHistory(key, value)
      )}

      {isFamilyHistoryOpen && (
        <div className="modal_history" id="modal">
          <div className="modal-content_history">
            <div className="modal-header_history">
              <div className="modal-title flex items-center text-red-700 font-semibold text-lg mb-4">
                <span className="material-icons mr-2 text-red-500">👨‍👩‍👧‍👦</span>
                Family History
              </div>
              <button
                className="close-btn_history"
                onClick={() => {
                  setIsFamilyHistoryOpen(false);
                }}
              >
                &times;
              </button>
            </div>

            <div className="modal-body_history" id="modal-body">
              {FamilyHistorydata.map(({ category, label, options }, index) => (
                <div className="category_history" key={index}>
                  <h4>{label}</h4>
                  {Object.entries(options).map(([key, optionLabel], i) => (
                    <div key={i} className="flex flex-col gap-1 mb-2">
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          disabled
                          checked={formData[category][key] || false}
                          onChange={(e) =>
                            handleCheckboxChange(category, key, e.target.checked)
                          }
                        />
                        {optionLabel}
                      </label>

                      {/* If "other" is checked → show input */}
                      {key.toLowerCase().includes("other") &&
                        formData[category][key] && (
                          <input
                            type="text"
                            placeholder="Please specify"
                            className="border p-1 rounded w-full max-w-xs"
                            value={formData[category][`${key}Text`] || ""}
                            onChange={(e) =>
                              handleOtherTextChange(
                                category,
                                key,
                                e.target.value
                              )
                            }
                          />
                        )}
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div className="modal-footer_history">
              <button
                onClick={() => {
                  setIsFamilyHistoryOpen(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientFamilyHistory;
